import React, { useEffect, useState, useRef, useCallback } from "react";

import { Map, TileLayer, Marker, Popup, Circle } from "react-leaflet";

import Grid from "@material-ui/core/Grid";
import endPoints from "../../shared/endPoints.json";

const LocationMap = (props) => {
    const lastLocation = {
        latitude: props.location.data.lastKnownLocation.latitude,
        longitude: props.location.data.lastKnownLocation.longitude,
        dateCreated: props.location.data.lastKnownLocation.dateCreated
    }
    let marker;
    const [lastKnownLocation, setLastKnownLocation] = useState(lastLocation);

    const openPopup = useCallback(
        (marker) => {
            if (marker && marker.leafletElement) {
                marker.leafletElement.openPopup();
            }
        },
        [marker]
    );
    return (
        <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={4}>
                <Map
                    style={{ height: "80vh", width: "90vw", margin: "10px" }}
                    center={(lastKnownLocation.longitude !== null && lastKnownLocation.latitude !== null) ? (
                        [lastKnownLocation.latitude, lastKnownLocation.longitude]
                    ) : [0, 0]}
                    zoom={6}
                >
                    <TileLayer
                        attribution={`&copy; <a href="${endPoints.OSMCOPYRIGHTLINK}">OpenStreetMap</a> contributors`}
                        url={endPoints.OSMMAPTILEURL}
                    />
                    <Marker
                        position={(lastKnownLocation.longitude !== null && lastKnownLocation.latitude !== null) ? (
                            [lastKnownLocation.latitude, lastKnownLocation.longitude]
                        ) : [0, 0]}
                        ref={openPopup}
                    >
                        <Popup>
                            {
                                (lastKnownLocation.longitude !== null && lastKnownLocation.latitude !== null) ?
                                    (
                                        <>
                                            <div>
                                                Ημερομηνία Τελευταίας Τοποθεσίας:
                                            </div>
                                            <div>
                                                {lastKnownLocation.dateCreated}
                                            </div>
                                        </>
                                    ) :
                                    <div>
                                        Δεν εντοπίστηκε Τοποθεσία
                                    </div>
                            }
                        </Popup>
                    </Marker>
                </Map>
            </Grid>
        </Grid>
    )
}

export default LocationMap;